import { useState, useEffect, useRef } from "react";
import axios from "axios";
import { motion, useInView, animate } from "framer-motion";
import { useContent } from "../context/ContentContext";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const SalesCounter = () => {
  const { content } = useContent();
  const sales = content.sales || {};
  const [target, setTarget] = useState(null);
  const [display, setDisplay] = useState(0);
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-80px" });
  const started = useRef(false);

  useEffect(() => {
    axios.get(`${API}/stats/sales`).then((r) => setTarget(r.data.count)).catch(() => setTarget(0));
  }, []);

  useEffect(() => {
    if (inView && target != null && !started.current) {
      started.current = true;
      const controls = animate(0, target, {
        duration: 2,
        ease: [0.16, 1, 0.3, 1],
        onUpdate: (v) => setDisplay(Math.floor(v)),
      });
      return () => controls.stop();
    }
  }, [inView, target]);

  if (!target || target < 1) return null; // honest: hide the counter until there are real sales

  return (
    <section ref={ref} className="relative py-20 lg:py-28 border-y border-white/10 bg-[#0a0a0a] overflow-hidden">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 flex flex-col items-center text-center">
        <span className="font-mono text-xs uppercase tracking-[0.3em] text-accent mb-6">// Live Count</span>        <motion.div
          initial={{ opacity: 0, scale: 0.9 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
          className="font-display font-black tracking-tighter leading-none text-[clamp(4rem,14vw,11rem)]"
        >
          {display.toLocaleString()}<span className="text-accent">+</span>
        </motion.div>
        <p data-testid="sales-counter-label" className="mt-4 font-display font-bold uppercase tracking-tight text-xl sm:text-3xl text-white/80">
          {sales.label || "operatives have ghosted the grid"}
        </p>
        <p className="mt-4 font-mono text-xs uppercase tracking-[0.2em] text-white/35 max-w-md">
          {sales.sub || "Every purchase is one more person off the radar. Join the resistance."}
        </p>
      </div>
    </section>
  );
};
